export default {"src":"/_next/static/media/listing.a3456456.svg","height":53,"width":52,"blurWidth":0,"blurHeight":0};